var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"short-info-box"},[_c('div',{staticClass:"avatar-name"},[_vm._v("@"+_vm._s(_vm.item.nick_name))]),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.item.title)+" "),_vm._l((_vm.item.label),function(item,index){return _c('span',{key:index},[_vm._v("#"+_vm._s(item))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }